"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeAndDecodeAvatar = exports.generatePresignedAvatarUrl = exports.resetPasswordChange = exports.resetPasswordSendEmail = exports.verifyEmail = exports.removeAccount = exports.changePassword = exports.editUser = exports.getUserDetails = exports.logOut = exports.logIn = exports.resend = exports.signUp = void 0;
const request_1 = __importStar(require("./request"));
const handleError_1 = require("./handleError");
const authStorage_1 = require("../services/authStorage");
const signUp = async ({ fullName, email, password, language }) => {
    try {
        const { data, status } = await (0, request_1.default)(request_1.POST, 'account/create', {
            username: fullName,
            email: email,
            password: password,
            language: language
        });
        return { data, status };
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.signUp = signUp;
const resend = async (email, language) => {
    try {
        const { data, status } = await (0, request_1.default)(request_1.POST, 'account/resend_code', {
            email: email,
            language: language
        });
        return { data, status };
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.resend = resend;
const logIn = async ({ email, password }) => {
    try {
        const { data, status } = await (0, request_1.default)(request_1.POST, 'account/login', {
            email: email,
            password: password,
        });
        return { data, status };
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.logIn = logIn;
const logOut = async () => {
    try {
        const refreshToken = await (0, authStorage_1.authStorageManager)(authStorage_1.secureStorageActionTypes.GET, authStorage_1.secureStorageKeys.REFRESH_TOKEN);
        // if (Platform.OS !== "web" && Device.isDevice) {
        //     Notifications.getExpoPushTokenAsync({
        //         projectId: Constants.expoConfig?.extra?.eas.projectId,
        //     }).then(token => token && deactivatePushNotificationToken(token.data));
        // }
        await (0, request_1.default)(request_1.POST, 'account/logout', { refresh_token: refreshToken });
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.logOut = logOut;
const getUserDetails = async () => {
    try {
        const { data } = await (0, request_1.default)(request_1.GET, 'account/me');
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.getUserDetails = getUserDetails;
const editUser = async (payload) => {
    try {
        const { data } = await (0, request_1.default)(request_1.PUT, 'account/me', payload);
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.editUser = editUser;
const changePassword = async (payload) => {
    try {
        const { data } = await (0, request_1.default)(request_1.PUT, 'account/me/password', payload);
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.changePassword = changePassword;
const removeAccount = async (payload) => {
    try {
        await (0, request_1.default)(request_1.POST, 'account/me/remove', payload);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.removeAccount = removeAccount;
const verifyEmail = async (token) => {
    try {
        const { data, status } = await (0, request_1.default)(request_1.POST, 'account/verify_email', {
            token
        });
        return { data, status };
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.verifyEmail = verifyEmail;
const resetPasswordSendEmail = async (payload) => {
    try {
        await (0, request_1.default)(request_1.POST, 'account/reset_password', payload);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.resetPasswordSendEmail = resetPasswordSendEmail;
const resetPasswordChange = async (payload) => {
    try {
        await (0, request_1.default)(request_1.POST, 'account/reset_password/verify', payload);
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.resetPasswordChange = resetPasswordChange;
const generatePresignedAvatarUrl = async () => {
    try {
        const { data } = await (0, request_1.default)(request_1.GET, 'account/me/generate_avatar_presigned_url');
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.generatePresignedAvatarUrl = generatePresignedAvatarUrl;
const resizeAndDecodeAvatar = async () => {
    try {
        const { data } = await (0, request_1.default)(request_1.GET, 'account/me/resize_avatar');
        return data;
    }
    catch (error) {
        throw (0, handleError_1.handleError)(error);
    }
};
exports.resizeAndDecodeAvatar = resizeAndDecodeAvatar;
